import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { ForgotPasswordForm } from '../../components/auth';

export default function ForgotPassword() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-linen px-4 py-8">
      <Card className="w-full max-w-md p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-8">
            <img src="/logo.png" alt="CareCal" className="h-10 w-auto" />
          </div>
          <h1 className="font-display text-3xl font-bold text-blueviolet mb-2">Forgot your password?</h1>
        </div>

        <ForgotPasswordForm />

        <div className="mt-6 flex justify-center gap-4 font-body text-sm">
          <Link
            to="/auth/login"
            className="font-medium text-blueviolet hover:text-blueviolet-light text-center underline"
          >
            Log in
          </Link>
          <Link
            to="/auth/register"
            className="font-medium text-blueviolet hover:text-blueviolet-light text-center underline"
          >
            Create New Account
          </Link>
        </div>
      </Card>
    </div>
  );
}
